<template>
  <div>
    <avue-crud
      :option="tableOption"
      :table-loading="loading"
      :data="listData"
      :page.sync="tablePage"
      @on-load="loadData"
    >
    </avue-crud>
  </div>
</template>
<script>
import { getRebotTaskList } from '@/api/nursingHome/artificalDevice';

export default {
  props: ['row'],
  data() {
    return {
      listData: [], // 列表数据
      loading: false,
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 数据的表格展示配置项
      tableOption: {
        border: true,
        index: true,
        columnBtn: false,
        refreshBtn: false,
        searchShowBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '任务ID',
            prop: 'taskKey',
            minWidth: 80,
          },
          {
            label: '任务时间',
            prop: 'taskTime',
            width: 140,
          },
          {
            label: '任务名称',
            prop: 'taskName',
            minWidth: 120,
          },
          {
            label: '任务描述',
            prop: 'taskMsg',
            minWidth: 200,
          },
        ],
      },
    };
  },
  methods: {
    loadData(page) {
      page = page || this.tablePage;
      this.loading = true;
      getRebotTaskList({
        current: page.currentPage,
        size: page.pageSize,
        deviceId: this.row.id,
      }).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
